var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logs"},[_c('h1',[_vm._v("Logs")]),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerId),expression:"customerId"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.customerId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getLogs]}},[_c('option',{attrs:{"value":"ffffffff-ffff-ffff-ffff-ffffffffffff","selected":""}},[_vm._v("<All Customers>")]),_vm._l((_vm.customers),function(customer){return _c('option',{key:customer.customerId,domProps:{"value":customer.customerId}},[_vm._v(_vm._s(customer.customerName))])})],2),_c('datepicker',{attrs:{"value":_vm.startDate,"disabled-dates":_vm.disabledDates},on:{"selected":_vm.setStartDate}}),_vm._v(" - "),_c('datepicker',{attrs:{"value":_vm.endDate,"disabled-dates":_vm.disabledDates},on:{"selected":_vm.setEndDate}})],1),_c('div',{staticClass:"table-wrapper loader-container"},[(_vm.logs)?_c('vue-good-table',{attrs:{"columns":[
        {
          label: 'Customer',
          field: 'site'
        },
        {
          label: 'Component',
          field: 'application'
        },
        {
          label: 'Level',
          field: 'level'
        },
        {
          label: 'Date',
          field: 'date',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Message',
          field: 'message',
          tdClass: 'logs-message'
        }
      ],"rows":_vm.logs}}):_vm._e(),_vm._l((_vm.pageCount),function(i){return _c('button',{key:i,class:{ active: i == _vm.page },on:{"click":function($event){return _vm.setPage(i)}}},[_vm._v(" "+_vm._s(i)+" ")])}),_c('Loader',{attrs:{"loading":_vm.loadingLogs}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }